"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitGallery = void 0;
const react_1 = require("@chakra-ui/react");
const faGithub_1 = require("@fortawesome/free-brands-svg-icons/faGithub");
const react_2 = __importDefault(require("react"));
const UiKitLite_1 = require("./UiKitLite");
const Buttons_1 = require("./Gallery/Buttons");
const ButtonsWithIcons_1 = require("./Gallery/ButtonsWithIcons");
const AllButtons_1 = require("./Gallery/AllButtons");
const DisabledButtons_1 = require("./Gallery/DisabledButtons");
const Collapsible_1 = require("./Gallery/Collapsible");
const Text_1 = require("./Gallery/Text");
const Hints_1 = require("./Gallery/Hints");
const ExtendingHints_1 = require("./Gallery/ExtendingHints");
const HorizontalLayouts_1 = require("./Gallery/HorizontalLayouts");
const VerticalLayouts_1 = require("./Gallery/VerticalLayouts");
const Select_1 = require("./Gallery/Select");
const Tabs_1 = require("./Gallery/Tabs");
const Boxes_1 = require("./Gallery/Boxes");
const Table_1 = require("./Gallery/Table");
const Modal_1 = require("./Gallery/Modal");
const Tags_1 = require("./Gallery/Tags");
const Spinner_1 = require("./Gallery/Spinner");
const SpinnerWithText_1 = require("./Gallery/SpinnerWithText");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const TabsLabelsOnly_1 = require("./Gallery/TabsLabelsOnly");
const TabsWithIcons_1 = require("./Gallery/TabsWithIcons");
const DatePicker_1 = require("./Gallery/DatePicker");
const IconOnlyButtons_1 = require("./Gallery/IconOnlyButtons");
const Labels_1 = require("./Gallery/Labels");
const Tooltip_1 = require("./Gallery/Tooltip");
const IconsStatus_1 = require("./Gallery/IconsStatus");
const Checkboxes_1 = require("./Gallery/Checkboxes");
const Breadcrumb_1 = require("./Gallery/Breadcrumb");
const Colors_1 = require("./Gallery/Colors");
const Toggle_1 = require("./Gallery/Toggle");
const RadioGroup_1 = require("./Gallery/RadioGroup");
const FileDrop_1 = require("./Gallery/FileDrop");
const ProgressBar_1 = require("./Gallery/ProgressBar");
const Functions_1 = require("./Gallery/Functions");
const howToRemarks = {
    Colors: `To use a standard UiKit color e.g. primaryBlue50 (${UiKitLite_1.UiKitLite.consistency.primaryBlue50}) simply prefix the
  color name with UiKit.consistency i.e. UiKit.consistency.primaryBlue50 and this will return the color
  code (${UiKitLite_1.UiKitLite.consistency.primaryBlue50}).`,
    Buttons: `When using buttons from UiKit you have 3 main choices that will
    affect appearance. First, which color and fill variant do you want?
    Primary, Secondary, Tertiary, Danger, or DangerBorderless? Second,
    what exact combination of text and icons do you want? You can set a
    leftIcon and/or a rightIcon; if you simply want an icon button with
    no text at all then set the text to the empty string and set the
    leftIcon prop. Third, size - do you want to have a small button
    or not? You control this with the isSmall prop.`,
    ButtonsWithIcons: '',
    DisabledButtons: '',
    IconButtons: '',
    AllButtons: '',
    Tooltip: '',
    Collapsible: '',
    Text: '',
    Breadcrumb: 'Breadcrumbs are actually very simple. They are just a series of either clickable or non-clickable text labels',
    Tags: '',
    Hints: 'Hints are a good way to make text content stand out; especially for warnings, errors, and tips!',
    ExtendingHints: `Everything inside the Hint component is configurable; whatever
    the child JSX of your hint is will be included in the Hint.`,
    HorizontalLayouts: '',
    VerticalLayouts: '',
    Select: '',
    Tabs: '',
    NumberedTabs: '',
    TabsWithIcons: '',
    TabsLabelsOnly: '',
    Boxes: '',
    Labels: '',
    DatePicker: '',
    Tables: '',
    Spinner: '',
    SpinnerWithText: '',
    Modal: '',
    Checkboxes: '',
    Toggle: '',
    IconsStatus: '',
    RadioGroup: '',
    FileDrop: '',
    ProgressBar: '',
};
const pageTitle = 'UiKit Component Gallery';
const spreadTags = (obj, prefix) => {
    return Object.keys(obj).map(k => `${prefix}.${k}`);
};
const galleryItems = {
    ['Colors']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Colors.tsx',
        jsx: react_2.default.createElement(Colors_1.Colors, null),
        tag: [],
        howToRemarks: howToRemarks.Colors,
    },
    ['Buttons']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Buttons.tsx',
        jsx: react_2.default.createElement(Buttons_1.Buttons, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Button, 'UiKit.Button'),
        howToRemarks: howToRemarks.Buttons,
    },
    ['Buttons with Icons']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/ButtonsWithIcons.tsx',
        jsx: react_2.default.createElement(ButtonsWithIcons_1.ButtonsWithIcons, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Button, 'UiKit.Button'),
        howToRemarks: howToRemarks.ButtonsWithIcons,
    },
    ['Disabled Buttons']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/DisabledButtons.tsx',
        jsx: react_2.default.createElement(DisabledButtons_1.DisabledButtons, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Button, 'UiKit.Button'),
        howToRemarks: howToRemarks.DisabledButtons,
    },
    ['Icon Buttons']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/IconOnlyButtons.tsx',
        jsx: react_2.default.createElement(IconOnlyButtons_1.IconOnlyButtons, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Button, 'UiKit.Button'),
        howToRemarks: howToRemarks.IconButtons,
    },
    ['All Buttons']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/AllButtons.tsx',
        jsx: react_2.default.createElement(AllButtons_1.AllButtons, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Button, 'UiKit.Button'),
        howToRemarks: howToRemarks.AllButtons,
    },
    ['Status Icons']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/IconsStatus.tsx',
        jsx: react_2.default.createElement(IconsStatus_1.IconsStatus, null),
        tag: ['UiKit.Icons.Status'],
        howToRemarks: howToRemarks.IconsStatus,
    },
    ['Tooltip']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Tooltip.tsx',
        jsx: react_2.default.createElement(Tooltip_1.Tooltip, null),
        tag: ['UiKit.Tooltip'],
        howToRemarks: howToRemarks.Tooltip,
    },
    ['Collapsible']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Collapsible.tsx',
        jsx: react_2.default.createElement(Collapsible_1.Collapsible, null),
        tag: ['UiKit.Collapsible'],
        howToRemarks: howToRemarks.Collapsible,
    },
    ['Text']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Text.tsx',
        jsx: react_2.default.createElement(Text_1.Text, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Text, 'UiKit.Text'),
        howToRemarks: howToRemarks.Text,
    },
    ['Breadcrumbs']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Breadcrumb.tsx',
        jsx: react_2.default.createElement(Breadcrumb_1.Breadcrumb, null),
        tag: ['UiKit.Text.Breadcrumb'],
        howToRemarks: howToRemarks.Breadcrumb,
    },
    ['Tags']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Tags.tsx',
        jsx: react_2.default.createElement(Tags_1.Tags, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Tag, 'UiKit.Tag'),
        howToRemarks: howToRemarks.Tags,
    },
    ['Hints']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Hints.tsx',
        jsx: react_2.default.createElement(Hints_1.Hints, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Hint, 'UiKit.Hint'),
        howToRemarks: howToRemarks.Hints,
    },
    ['Extending Hints']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/ExtendingHints.tsx',
        jsx: react_2.default.createElement(ExtendingHints_1.ExtendingHints, null),
        tag: spreadTags(UiKitLite_1.UiKitLite.Hint, 'UiKit.Hint'),
        howToRemarks: howToRemarks.ExtendingHints,
    },
    ['Horizontal Layouts']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/HorizontalLayouts.tsx',
        jsx: react_2.default.createElement(HorizontalLayouts_1.HorizontalLayouts, null),
        tag: [],
        howToRemarks: howToRemarks.HorizontalLayouts,
    },
    ['Vertical Layouts']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/VerticalLayouts.tsx',
        jsx: react_2.default.createElement(VerticalLayouts_1.VerticalLayouts, null),
        tag: [],
        howToRemarks: howToRemarks.VerticalLayouts,
    },
    ['Select']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Select.tsx',
        jsx: react_2.default.createElement(Select_1.Select, null),
        tag: [],
        howToRemarks: howToRemarks.Select,
    },
    ['Tabs']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Tabs.tsx',
        jsx: react_2.default.createElement(Tabs_1.Tabs, { numbered: false }),
        tag: [],
        howToRemarks: howToRemarks.Tabs,
    },
    ['Numbered Tabs']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Tabs.tsx',
        jsx: react_2.default.createElement(Tabs_1.Tabs, { numbered: true }),
        tag: [],
        howToRemarks: howToRemarks.NumberedTabs,
    },
    ['Tabs With Icons']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/TabsWithIcons.tsx',
        jsx: react_2.default.createElement(TabsWithIcons_1.TabsWithIcons, null),
        tag: [],
        howToRemarks: howToRemarks.TabsWithIcons,
    },
    ['Tabs - Labels Only']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/TabsLabelsOnly.tsx',
        jsx: react_2.default.createElement(TabsLabelsOnly_1.TabsLabelsOnly, null),
        tag: [],
        howToRemarks: howToRemarks.TabsLabelsOnly,
    },
    ['Boxes']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Boxes.tsx',
        jsx: react_2.default.createElement(Boxes_1.Boxes, null),
        tag: [],
        howToRemarks: howToRemarks.Boxes,
    },
    ['Labels']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Labels.tsx',
        jsx: react_2.default.createElement(Labels_1.Labels, null),
        tag: ['UiKit.Form.Label'],
        howToRemarks: howToRemarks.Labels,
    },
    ['Date Picker']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/DatePicker.tsx',
        jsx: react_2.default.createElement(DatePicker_1.DatePicker, null),
        tag: ['UiKit.Form.Date'],
        howToRemarks: howToRemarks.DatePicker,
    },
    ['Tables']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Table.tsx',
        jsx: react_2.default.createElement(Table_1.Table, null),
        tag: [],
        howToRemarks: howToRemarks.Tables,
    },
    ['Spinner']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Spinner.tsx',
        jsx: react_2.default.createElement(Spinner_1.Spinner, null),
        tag: [],
        howToRemarks: howToRemarks.Spinner,
    },
    ['Spinner with text']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/SpinnerWithText.tsx',
        jsx: react_2.default.createElement(SpinnerWithText_1.SpinnerWithText, null),
        tag: [],
        howToRemarks: howToRemarks.SpinnerWithText,
    },
    ['Modal']: {
        showInABox: false,
        sourceURL: 'src/views/Gallery/Modal.tsx',
        jsx: react_2.default.createElement(Modal_1.Modal, null),
        tag: ['UiKit.Modal'],
        howToRemarks: howToRemarks.Modal,
    },
    ['Checkbox']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Checkboxes.tsx',
        jsx: react_2.default.createElement(Checkboxes_1.Checkboxes, null),
        tag: ['UiKit.Form.Checkbox'],
        howToRemarks: howToRemarks.Checkboxes,
    },
    ['Toggle']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Toggle.tsx',
        jsx: react_2.default.createElement(Toggle_1.Toggle, null),
        tag: ['UiKit.Form.Toggle'],
        howToRemarks: howToRemarks.Toggle,
    },
    ['Radio Group']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/RadioGroup.tsx',
        jsx: react_2.default.createElement(RadioGroup_1.RadioGroup, null),
        tag: ['UiKit.Form.RadioGroup'],
        howToRemarks: howToRemarks.RadioGroup,
    },
    ['File Drop']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/FileDrop.tsx',
        jsx: react_2.default.createElement(FileDrop_1.FileDrop, null),
        tag: ['UiKit.Form.FileDrop'],
        howToRemarks: howToRemarks.FileDrop,
    },
    ['Progress Bar']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/ProgressBar.tsx',
        jsx: react_2.default.createElement(ProgressBar_1.ProgressBarHorizontal, null),
        tag: ['UiKit.Progress.Horizontal'],
        howToRemarks: howToRemarks.ProgressBar,
    },
    ['Functions']: {
        showInABox: true,
        sourceURL: 'src/views/Gallery/Functions.tsx',
        jsx: react_2.default.createElement(Functions_1.Functions, null),
        tag: ['UiKit.Function.downloadFile'],
        howToRemarks: howToRemarks.ProgressBar,
    },
};
const getAnchorIdForTitle = (title) => {
    return `ui-${title.replace(/[^0-9a-zA-Z]/g, '')}`;
};
const GallerySection = (props) => {
    const viewExampleCodeButtonText = 'View Example Code';
    const githubRootURL = 'https://github.com/datavant/codebase';
    const githubFullURL = `${githubRootURL}/blob/master/connect_cloud_portal/frontend/${props.sourceURL}`;
    const viewExampleCodeButton = (react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Tertiary, { text: viewExampleCodeButtonText, onClick: () => window.open(githubFullURL, '_blank'), leftIcon: react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faGithub_1.faGithub, size: '1x' }) }));
    const id = getAnchorIdForTitle(props.title);
    const title = react_2.default.createElement(UiKitLite_1.UiKitLite.Text.Heading2, { text: props.title });
    const titleWithCodeTooltip = (react_2.default.createElement(react_1.Tooltip, { label: react_2.default.createElement(react_1.VStack, { align: 'stretch', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.Heading3, { text: `${props.title} JSX Summary` }),
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null,
                "Here is a top-level list of the opening JSX tags you would use to use ",
                react_2.default.createElement("b", null, props.title),
                " in your React code. To see a more complete example click",
                ' ',
                react_2.default.createElement("span", { style: { color: UiKitLite_1.UiKitLite.consistency.primaryBlue50 } }, viewExampleCodeButtonText),
                " to the right of this section."),
            react_2.default.createElement(react_1.VStack, { align: 'stretch', spacing: '0' }, props.tags.map(tag => (react_2.default.createElement("code", { style: {
                    color: '#333',
                    padding: '5px 0',
                }, key: tag },
                "<",
                tag,
                "\u00A0/>"))))), "aria-label": '', placement: 'right', borderRadius: UiKitLite_1.UiKitLite.consistency.borderRadius, border: `1px solid ${UiKitLite_1.UiKitLite.consistency.pageBackground}`, arrowSize: 15, hasArrow: false, bgColor: UiKitLite_1.UiKitLite.consistency.white, padding: '20px', width: '450px' },
        react_2.default.createElement(react_1.HStack, { align: 'center' }, title)));
    return (react_2.default.createElement(react_1.VStack, { id: id, align: 'stretch', spacing: 5 },
        react_2.default.createElement(react_1.HStack, { align: 'center', spacing: 0, justify: 'flex-start' },
            react_2.default.createElement(UiKitLite_1.UiKitLite.WrapWithTooltip, { tooltip: `Open URL link to the ${props.title} section of the ${pageTitle}`, placement: 'bottom' },
                react_2.default.createElement(react_1.Box, null,
                    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Tertiary, { text: '', leftIcon: 'bookmark', isSmall: true, onClick: () => window.open(`/ui/${id}`) }))),
            react_2.default.createElement(react_1.HStack, { align: 'center', justify: 'space-between', flex: 1 },
                props.tags.length ? titleWithCodeTooltip : title,
                viewExampleCodeButton)),
        props.children));
};
const scrollPageToId = (id) => {
    const elementToScrollTo = document.getElementById(id);
    if (elementToScrollTo) {
        const yOffset = -65;
        const y = elementToScrollTo.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y,
            behavior: 'smooth',
        });
    }
};
const UiKitGallery = () => {
    const galleryItemTitles = Object.keys(galleryItems);
    galleryItemTitles.sort();
    const tableOfContents = (react_2.default.createElement(react_1.Wrap, { align: 'center', spacing: 5, pb: UiKitLite_1.UiKitLite.consistency.buffer, borderBottom: `1px solid ${UiKitLite_1.UiKitLite.consistency.gray11100}` }, galleryItemTitles.map(galleryItemTitle => {
        return (react_2.default.createElement(react_1.WrapItem, { key: galleryItemTitle },
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.Clickable, { text: galleryItemTitle, onClick: () => scrollPageToId(getAnchorIdForTitle(galleryItemTitle)) })));
    })));
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(UiKitLite_1.UiKitLite.Text.Heading1, { text: pageTitle }),
        tableOfContents,
        Object.entries(galleryItems).map(([key, value]) => {
            return (react_2.default.createElement(GallerySection, { title: key, key: key, sourceURL: value.sourceURL, tags: value.tag },
                react_2.default.createElement(react_1.HStack, { align: 'center' }, value.howToRemarks !== '' ? (react_2.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { title: 'Usage Tip', textLines: [value.howToRemarks], colored: true })) : (react_2.default.createElement(react_2.default.Fragment, null))),
                value.showInABox ? react_2.default.createElement(UiKitLite_1.UiKitLite.InfoBox, null, value.jsx) : value.jsx));
        })));
};
exports.UiKitGallery = UiKitGallery;
